{
  "app": {
    "name": "meta-mdm",
    "tagline": "मास्टर डेटा, रनटाइम पर परिभाषित",
    "console": "एडमिन कंसोल",
    "footer": "© {{year}} meta-mdm. सर्वाधिकार सुरक्षित।"
  },
  "nav": {
    "skipToContent": "मुख्य सामग्री पर जाएँ",
    "primary": "मुख्य",
    "breadcrumbs": "ब्रेडक्रम्ब",
    "openMenu": "नेविगेशन खोलें",
    "closeMenu": "नेविगेशन बंद करें",
    "group": {
      "data": "डेटा",
      "governance": "अभिशासन",
      "admin": "प्रशासन"
    },
    "breadcrumb": {
      "new": "नया",
      "edit": "संपादित करें",
      "record": "रिकॉर्ड",
      "schema": "स्कीमा",
      "submission": "सबमिशन"
    },
    "dashboard": "डैशबोर्ड",
    "masterTypes": "मास्टर प्रकार",
    "records": "रिकॉर्ड",
    "submissions": "सबमिशन",
    "handovers": "हैंडओवर",
    "audit": {
      "masterData": "ऑडिट",
      "userManagement": "उपयोगकर्ता ऑडिट"
    },
    "users": "उपयोगकर्ता",
    "account": "खाता",
    "about": {
      "dashboard": "आप पर क्या लंबित है, और कितना मास्टर डेटा मौजूद है।",
      "records": "रिकॉर्ड स्वयं देखें और संपादित करें, एक बार में एक मास्टर टाइप।",
      "masterTypes": "यह टेनेंट जिन प्रकार का मास्टर डेटा परिभाषित करता है, और हर एक का स्कीमा।",
      "submissions": "निर्णय की प्रतीक्षा कर रहे बदलाव, और वे जो आपने स्वयं जमा किए।",
      "handovers": "किसी सबमिशन को दूसरे समीक्षक को सौंपने के अनुरोध।",
      "auditMasterData": "किसने कौन-सा रिकॉर्ड कब बदला, और बदलाव क्या था।",
      "auditUserManagement": "किसने किसे प्रावधानित किया, सक्रिय किया या भूमिका दी।",
      "users": "लोगों को प्रावधानित करें, भूमिकाएँ दें, और पहुँच सक्रिय या निष्क्रिय करें।"
    }
  },
  "auth": {
    "signIn": "साइन इन करें",
    "signInPrompt": "meta-mdm में जारी रखने के लिए साइन इन करें।",
    "signInWithGoogle": "Google से जारी रखें",
    "signInWithMicrosoft": "Microsoft से जारी रखें",
    "signOut": "साइन आउट करें",
    "signedInAs": "{{email}} के रूप में साइन इन",
    "checkingSession": "आपका सत्र जाँचा जा रहा है",
    "pending": {
      "title": "आपका खाता स्वीकृति की प्रतीक्षा में है",
      "body": "मास्टर डेटा देखने से पहले किसी प्रशासक को आपका खाता सक्रिय करना होगा। आपको और कुछ नहीं करना है — जैसे ही वे ऐसा करेंगे, यह पृष्ठ काम करने लगेगा।",
      "action": "फिर से जाँचें"
    },
    "deactivated": {
      "title": "आपका खाता निष्क्रिय कर दिया गया है",
      "body": "आप साइन इन तो कर सकते हैं, पर अब आपके पास मास्टर डेटा तक पहुँच नहीं है। यदि यह गलती लगती है तो प्रशासक से संपर्क करें।"
    },
    "noPermissions": {
      "title": "अभी तक कोई पहुँच नहीं दी गई है",
      "body": "आपका खाता सक्रिय है पर उसमें कोई भूमिका नहीं है, इसलिए दिखाने को कुछ नहीं है। कोई प्रशासक आपको किसी मास्टर प्रकार तक पहुँच दे सकता है।"
    }
  },
  "table": {
    "search": "खोजें",
    "searchHint": "खोजने के लिए / दबाएँ",
    "loading": "पंक्तियाँ लोड हो रही हैं",
    "loadingMore": "और पंक्तियाँ लोड हो रही हैं",
    "refreshing": "ताज़ा किया जा रहा है",
    "loadMore": "और लोड करें",
    "endOfResults": "बस इतना ही है",
    "sortedAscending": "आरोही क्रम में",
    "sortedDescending": "अवरोही क्रम में",
    "notSorted": "क्रमित नहीं",
    "empty": {
      "title": "अभी यहाँ कुछ नहीं है",
      "body": "रिकॉर्ड बनने के बाद वे इस तालिका में दिखाई देंगे।"
    },
    "noResults": {
      "title": "कोई मेल नहीं",
      "body": "आपके लगाए फ़िल्टर से कोई पंक्ति मेल नहीं खाती। खोज बढ़ाने के लिए कोई फ़िल्टर हटाएँ।",
      "clearFilters": "फ़िल्टर हटाएँ",
      "removeFilter": "{{field}} फ़िल्टर हटाएँ"
    },
    "error": {
      "title": "यह तालिका लोड नहीं हो सकी",
      "body": "कोई पंक्ति आने से पहले ही अनुरोध विफल हो गया। आमतौर पर फिर से कोशिश करने से काम बन जाता है; अगर नहीं, तो नीचे दी गई ट्रेस आईडी बताएँ।",
      "traceId": "ट्रेस आईडी"
    }
  },
  "diff": {
    "added": "जोड़ा गया",
    "removed": "हटाया गया",
    "changed": "बदला गया",
    "before": "पहले",
    "after": "बाद में",
    "none": "कुछ नहीं"
  },
  "common": {
    "retry": "फिर से कोशिश करें",
    "cancel": "रद्द करें",
    "confirm": "पुष्टि करें",
    "close": "बंद करें",
    "copy": "कॉपी करें",
    "copied": "कॉपी हो गया",
    "copyTraceId": "ट्रेस आईडी कॉपी करें",
    "required": "आवश्यक",
    "loading": "लोड हो रहा है",
    "theme": {
      "label": "थीम",
      "light": "हल्का",
      "dark": "गहरा",
      "system": "सिस्टम के अनुसार"
    },
    "locale": {
      "label": "भाषा",
      "en": "अंग्रेज़ी",
      "hi": "हिन्दी"
    },
    "aboutSection": "{{name}} के बारे में"
  },
  "status": {
    "draft": "ड्राफ़्ट",
    "pending": "समीक्षा बाकी",
    "approved": "स्वीकृत",
    "rejected": "अस्वीकृत",
    "cancelled": "रद्द",
    "active": "सक्रिय",
    "inactive": "निष्क्रिय",
    "uncommissioned": "अभी सक्रिय नहीं हुआ"
  },
  "errors": {
    "generic": {
      "title": "कुछ काम नहीं आया",
      "body": "अनुरोध पूरा नहीं हो सका। थोड़ी देर में फिर कोशिश करें।"
    },
    "offline": {
      "title": "कोई कनेक्शन नहीं",
      "body": "आपका ब्राउज़र सर्वर तक नहीं पहुँच सका। कनेक्शन जाँचें और फिर कोशिश करें।"
    },
    "notFound": {
      "title": "यह पृष्ठ मौजूद नहीं है",
      "body": "हो सकता है लिंक पुराना हो, या रिकॉर्ड हटा दिया गया हो।",
      "action": "डैशबोर्ड पर जाएँ"
    },
    "forbidden": {
      "title": "इस तक आपकी पहुँच नहीं है",
      "body": "इस कार्रवाई के लिए आपके खाते में कोई अनुमति नहीं है। कोई प्रशासक इसे दे सकता है।"
    }
  },
  "dashboard": {
    "sections": {
      "masterData_one": "मास्टर डेटा · {{count}} प्रकार",
      "masterData_other": "मास्टर डेटा · {{count}} प्रकार",
      "recentlyUpdated": "हाल में अपडेट किए गए",
      "approvals": "स्वीकृतियाँ"
    },
    "subtitle": "आज आपकी प्रतीक्षा में यह है।",
    "greeting": {
      "morning": "सुप्रभात, {{name}}",
      "afternoon": "शुभ दोपहर, {{name}}",
      "evening": "शुभ संध्या, {{name}}"
    },
    "cta": {
      "reviewSubmissions": "सबमिशन की समीक्षा करें",
      "goToRecords": "रिकॉर्ड देखें"
    },
    "currentRecords": "वर्तमान रिकॉर्ड",
    "countUnavailable": "गणना उपलब्ध नहीं",
    "filterTypes": "नाम से फ़िल्टर करें",
    "noRecentActivity": "हाल में कोई गतिविधि नहीं",
    "version": "संस्करण {{version}}",
    "pendingApproval": "स्वीकृति लंबित",
    "approvals": {
      "schema": "स्कीमा स्वीकृतियाँ",
      "record": "रिकॉर्ड सबमिशन"
    },
    "about": {
      "masterData": "आपके पढ़ने योग्य हर मास्टर टाइप के लिए एक टाइल, और उसमें कितने वर्तमान रिकॉर्ड हैं।",
      "recent": "आपके पढ़ने योग्य हर प्रकार में हाल ही में बदले गए रिकॉर्ड।",
      "approvals": "अभी कितना निर्णय की प्रतीक्षा में है।"
    }
  },
  "masterTypes": {
    "columns": {
      "code": "कोड",
      "name": "नाम",
      "status": "स्थिति"
    },
    "description": "यह टेनेंट जो मास्टर प्रकार परिभाषित करता है। रिकॉर्ड इन्हीं के विरुद्ध बनाए जाते हैं।"
  },
  "records": {
    "title": "रिकॉर्ड",
    "filterTypes": "नाम से फ़िल्टर करें",
    "description": "मास्टर डेटा, आपकी पहुँच वाले हर प्रकार के लिए एक अनुभाग।",
    "pickType": "रिकॉर्ड देखने के लिए कोई मास्टर प्रकार चुनें।",
    "noTypes": {
      "title": "आप कोई मास्टर प्रकार नहीं पढ़ सकते",
      "body": "अभी आपके खाते को किसी भी मास्टर प्रकार पर रिकॉर्ड की अनुमति नहीं है। कोई प्रशासक यह दे सकता है।"
    },
    "view": {
      "label": "दृश्य",
      "list": "सूची",
      "tree": "वृक्ष",
      "about": {
        "list": "इस प्रकार का हर रिकॉर्ड एक सपाट, क्रमबद्ध होने योग्य तालिका में।",
        "tree": "वही रिकॉर्ड अपने मूल के नीचे व्यवस्थित, एक बार में एक स्तर।"
      }
    },
    "columns": {
      "businessKey": "कुंजी",
      "name": "नाम",
      "status": "स्थिति",
      "active": "सक्रिय",
      "version": "संस्करण",
      "updated": "अद्यतन"
    },
    "includeInactive": "निष्क्रिय भी दिखाएँ",
    "statusFilter": {
      "label": "स्थिति",
      "all": "सभी"
    },
    "create": "नया रिकॉर्ड",
    "empty": {
      "title": "अभी कोई रिकॉर्ड नहीं",
      "body": "इस मास्टर प्रकार के लिए कुछ नहीं बनाया गया है। रिकॉर्ड ड्राफ़्ट के रूप में शुरू होता है और समीक्षक की स्वीकृति के बाद सबको दिखता है।"
    },
    "noSchema": {
      "title": "इस मास्टर प्रकार का कोई सक्रिय स्कीमा नहीं है",
      "body": "जब तक कोई स्कीमा संस्करण परिभाषित और स्वीकृत नहीं होता, रिकॉर्ड नहीं बनाए जा सकते। तब तक भरने को कुछ नहीं है।",
      "action": "स्कीमा परिभाषित करें"
    },
    "draftBadge": "आपका ड्राफ़्ट",
    "form": {
      "createTitle": "नया {{type}}",
      "amendTitle": "{{key}} में संशोधन",
      "editTitle": "{{key}} संपादित करें",
      "createDescription": "ड्राफ़्ट के रूप में सहेजा गया। सबमिट करने और समीक्षक की स्वीकृति के बाद यह सबको दिखेगा।",
      "amendDescription": "यह नया संस्करण बनाता है। समीक्षक की स्वीकृति तक मौजूदा संस्करण ही लागू रहता है।",
      "businessKey": "व्यावसायिक कुंजी",
      "businessKeyHint": "रिकॉर्ड की स्थायी पहचान। इसका अनुवाद नहीं होता, और बनने के बाद यह बदलती नहीं।",
      "parent": "मूल {{type}}",
      "parentLocked": "खुले ड्राफ़्ट का मूल तय है। बदलने के लिए इसे वापस लेकर फिर से शुरू करें।",
      "fields": "{{type}} के फ़ील्ड",
      "choose": "चुनें...",
      "save": "ड्राफ़्ट सहेजें",
      "saved": "ड्राफ़्ट सहेजा गया",
      "schemaInvalid": {
        "title": "इस मास्टर प्रकार का स्कीमा प्रस्तुत नहीं किया जा सकता",
        "body": "संग्रहीत परिभाषा त्रुटिपूर्ण है, इसलिए उससे कोई फ़ॉर्म नहीं बन सकता। इसे स्कीमा बिल्डर में ठीक करें। यहाँ लिखा कुछ भी सहेजा नहीं जा सकेगा।"
      }
    },
    "reference": {
      "placeholder": "खोजें...",
      "results": "मिलते-जुलते रिकॉर्ड",
      "noMatches": "कुछ नहीं मिला",
      "refine": "पहले {{count}} दिखाए जा रहे हैं। और लिखकर खोज सीमित करें।",
      "clear": "चयन हटाएँ"
    },
    "detail": {
      "fields": "फ़ील्ड",
      "hierarchy": "पदानुक्रम",
      "children": "संतति",
      "noChildren": "कोई रिकॉर्ड इसकी ओर संकेत नहीं करता।",
      "history": "संस्करण इतिहास",
      "historyEmpty": "आपको दिखने योग्य कोई संस्करण नहीं।",
      "viewAuditTrail": "पूरा ऑडिट ट्रेल देखें",
      "createdBy": "बनाया",
      "approvedBy": "स्वीकृत किया",
      "notApproved": "स्वीकृत नहीं",
      "version": "संस्करण {{version}}",
      "current": "वर्तमान",
      "noValue": "कोई नहीं",
      "actions": "क्रियाएँ",
      "edit": "ड्राफ़्ट संपादित करें",
      "amend": "नया संस्करण",
      "submit": "समीक्षा के लिए भेजें",
      "submitted": "समीक्षा के लिए भेजा गया",
      "deactivate": "निष्क्रिय करें",
      "reactivate": "पुनः सक्रिय करें",
      "cascade": "इसकी संतति भी निष्क्रिय करें",
      "confirmDeactivate": {
        "title": "यह रिकॉर्ड निष्क्रिय करें?",
        "body": "निष्क्रिय करना भी किसी अन्य बदलाव जैसा संस्करणबद्ध परिवर्तन है। यह समीक्षा के लिए भेजा जाता है, और स्वीकृति तक रिकॉर्ड लागू रहता है।"
      }
    },
    "tree": {
      "expand": "{{name}} खोलें",
      "collapse": "{{name}} बंद करें",
      "empty": "दिखाने को कोई रिकॉर्ड नहीं।",
      "loading": "संतति लोड हो रही है"
    },
    "cannotCreate": "आप ये रिकॉर्ड देख सकते हैं, जोड़ नहीं सकते। बनाने के लिए इस मास्टर टाइप पर creator भूमिका चाहिए।",
    "cannotCreateNoSchema": "इस मास्टर टाइप की कोई सक्रिय स्कीमा नहीं है, इसलिए भरने के लिए कोई फ़ील्ड नहीं है। पहले एक परिभाषित कराएँ और स्वीकृत कराएँ।"
  },
  "schema": {
    "title": "स्कीमा",
    "builderTitle": "{{type}} का स्कीमा",
    "description": "इस प्रकार के रिकॉर्ड जो फ़ील्ड रखते हैं। इन्हें बदलने पर नया संस्करण बनता है, जिसे लागू होने से पहले समीक्षक की स्वीकृति चाहिए।",
    "activeVersion": "सक्रिय: संस्करण {{version}}",
    "noActiveVersion": "अभी तक कोई संस्करण सक्रिय नहीं किया गया है।",
    "addField": "फ़ील्ड जोड़ें",
    "removeField": "{{name}} हटाएँ",
    "moveUp": "{{name}} ऊपर ले जाएँ",
    "moveDown": "{{name}} नीचे ले जाएँ",
    "field": {
      "untitled": "फ़ील्ड {{position}}",
      "name": "नाम",
      "nameHint": "छोटे अक्षर, बिना रिक्त स्थान। मान इसी कुंजी के अंतर्गत संग्रहीत होता है और बाद में इसका नाम नहीं बदला जा सकता।",
      "type": "प्रकार",
      "label": "लेबल",
      "required": "अनिवार्य",
      "localised": "हर भाषा के लिए अलग",
      "values": "मान्य मान",
      "valuesHint": "हर पंक्ति में एक।",
      "target": "किसकी ओर संकेत",
      "pattern": "पैटर्न",
      "minLength": "न्यूनतम लंबाई",
      "maxLength": "अधिकतम लंबाई",
      "minimum": "न्यूनतम",
      "maximum": "अधिकतम"
    },
    "types": {
      "string": "पाठ",
      "number": "संख्या",
      "integer": "पूर्णांक",
      "boolean": "हाँ या नहीं",
      "date": "तिथि",
      "datetime": "तिथि और समय",
      "enum": "सूची में से एक",
      "reference": "दूसरा रिकॉर्ड"
    },
    "noFields": "अभी कोई फ़ील्ड नहीं। बिना फ़ील्ड वाला स्कीमा खाली फ़ॉर्म बनाता है।",
    "saveDraft": "ड्राफ़्ट संस्करण सहेजें",
    "submit": "समीक्षा के लिए भेजें",
    "versions": "संस्करण",
    "compatibility": {
      "label": "संगतता",
      "compatible": "संगत",
      "breaking": "असंगत",
      "unknown": "अभी वर्गीकृत नहीं",
      "breakingBody": "मौजूदा रिकॉर्ड इस संस्करण के अनुरूप नहीं हैं। उनके माइग्रेट होने तक इसे सक्रिय नहीं किया जा सकता।"
    },
    "createType": {
      "action": "नया मास्टर प्रकार",
      "title": "नया मास्टर प्रकार",
      "code": "कोड",
      "codeHint": "छोटे अक्षर, अंक, डैश और अंडरस्कोर। स्थायी।",
      "name": "नाम",
      "parent": "मूल प्रकार",
      "noParent": "कोई नहीं। यह शीर्ष स्तर का प्रकार है",
      "create": "बनाएँ"
    },
    "cannotDefine": "आप यह स्कीमा देख सकते हैं, बदल नहीं सकते। फ़ील्ड परिभाषित करने के लिए इस मास्टर टाइप पर creator भूमिका चाहिए — कोई प्रशासक इसे दे सकता है।"
  },
  "forms": {
    "errors": {
      "required": "कोई मान भरें।",
      "wrongType": "इस फ़ील्ड के लिए यह मान्य मान नहीं है।",
      "minLength_one": "कम से कम {{count}} अक्षर लिखें।",
      "minLength_other": "कम से कम {{count}} अक्षर लिखें।",
      "maxLength_one": "अधिकतम {{count}} अक्षर लिखें।",
      "maxLength_other": "अधिकतम {{count}} अक्षर लिखें।",
      "minimum": "{{value}} या उससे अधिक भरें।",
      "maximum": "{{value}} या उससे कम भरें।",
      "pattern": "यह इस फ़ील्ड के अपेक्षित प्रारूप से मेल नहीं खाता।",
      "date": "कोई वास्तविक तिथि भरें।",
      "datetime": "कोई वास्तविक तिथि और समय भरें।",
      "oneOf": "इनमें से चुनें: {{values}}।",
      "localeRequired": "{{locale}} टैब भरें। यह अनिवार्य है।",
      "anyLocale": "कम से कम एक भाषा भरें।"
    }
  },
  "submissions": {
    "title": "सबमिशन",
    "description": "निर्णय की प्रतीक्षा कर रहे बदलाव, और जिन पर निर्णय हो चुका है।",
    "approve": "स्वीकृत करें",
    "reject": "अस्वीकार करें",
    "approved": "सबमिशन स्वीकृत हुआ",
    "rejected": "सबमिशन अस्वीकार हुआ",
    "changes": "इससे क्या बदलेगा",
    "decisionComment": "समीक्षक की टिप्पणी",
    "backToQueue": "कतार पर वापस",
    "unassigned": "अनिर्दिष्ट",
    "notSubmitted": "सबमिट नहीं हुआ",
    "cascadeNotice": "यह एक निर्णय {{count}} रिकॉर्ड पर लागू होगा। स्वीकृति सभी पर लागू होती है।",
    "columns": {
      "type": "मास्टर टाइप",
      "change": "बदलाव",
      "status": "स्थिति",
      "submittedBy": "सबमिट करने वाला",
      "reviewer": "समीक्षक",
      "waiting": "प्रतीक्षा",
      "subject": "विषय"
    },
    "kind": {
      "record": "रिकॉर्ड",
      "schema": "स्कीमा"
    },
    "action": {
      "create": "नया रिकॉर्ड",
      "update": "रिकॉर्ड संपादन",
      "deactivate": "निष्क्रिय करना",
      "reactivate": "पुनः सक्रिय करना",
      "import": "थोक आयात",
      "schema_version": "स्कीमा संस्करण"
    },
    "scope": {
      "label": "कतार",
      "mine": "मेरी प्रतीक्षा में",
      "submitted": "मैंने सबमिट किए",
      "all": "सब कुछ",
      "about": {
        "mine": "आपको सौंपे गए, और वे सब जो अभी किसी को नहीं सौंपे गए।",
        "submitted": "आपके जमा किए बदलाव, और उनका क्या हुआ।",
        "all": "टेनेंट का हर सबमिशन, निर्णय हुआ हो या नहीं।"
      }
    },
    "filter": {
      "status": "स्थिति",
      "kind": "प्रकार",
      "any": "कोई भी"
    },
    "age": {
      "fresh_one": "{{count}} दिन",
      "fresh_other": "{{count}} दिन",
      "ageing_one": "{{count}} दिन से प्रतीक्षारत",
      "ageing_other": "{{count}} दिन से प्रतीक्षारत",
      "stalled_one": "{{count}} दिन से अटका",
      "stalled_other": "{{count}} दिन से अटका"
    },
    "empty": {
      "mine": {
        "title": "आपकी प्रतीक्षा में कुछ नहीं है",
        "body": "आपको सौंपे गए सबमिशन यहाँ दिखते हैं। जिन पर कोई समीक्षक नियत नहीं है, वे निर्णय होने तक हर समीक्षक को दिखते हैं।"
      },
      "submitted": {
        "title": "आपने कुछ सबमिट नहीं किया",
        "body": "समीक्षा के लिए भेजे गए बदलाव यहाँ दिखते हैं, निर्णय के साथ।"
      },
      "all": {
        "title": "कोई सबमिशन नहीं मिला",
        "body": "ऊपर लगे फ़िल्टर से कुछ मेल नहीं खाता। और देखने के लिए फ़िल्टर हटाएँ।"
      }
    },
    "review": {
      "title": "समीक्षा: {{type}}"
    },
    "item": {
      "schemaVersion": "स्कीमा संस्करण {{version}}",
      "record": "रिकॉर्ड",
      "depth": "स्तर {{depth}}"
    },
    "diff": {
      "fields": "फ़ील्ड",
      "attributes": "रिकॉर्ड विशेषताएँ",
      "noChanges": "इस मद में कुछ नहीं बदला।",
      "noItems": "इस सबमिशन में दिखाने के लिए कोई मद नहीं है।"
    },
    "refusal": {
      "forbidden": "इस पर निर्णय लेने की अनुमति आपके पास नहीं है। इसके लिए इस मास्टर टाइप पर reviewer अनुदान चाहिए।",
      "self-review-refused": "आप अपना ही सबमिशन स्वीकृत नहीं कर सकते। समीक्षा किसी और को करनी होगी — यही अलगाव इस प्रक्रिया का उद्देश्य है।",
      "not-assigned-reviewer": "इस सबमिशन के नियत समीक्षक कोई और हैं। उनसे कहें, या हैंडओवर का अनुरोध करें।",
      "submission-not-pending": "इस सबमिशन पर निर्णय हो चुका है, अब स्वीकृत करने को कुछ नहीं बचा।",
      "insufficient-review-coverage": "यह बदलाव उन मास्टर टाइप तक पहुँचता है जिन पर आपके पास स्वीकृति का अनुदान नहीं है।",
      "insufficientCoverage": "इसे स्वीकृत करने के लिए इन पर reviewer अनुदान चाहिए: {{types}}।"
    },
    "rejectDialog": {
      "title": "इस सबमिशन को अस्वीकार करें",
      "body": "सबमिट करने वाले को आपकी टिप्पणी दिखेगी, और यह ऑडिट रिकॉर्ड में दर्ज होगी।",
      "comment": "आप इसे क्यों अस्वीकार कर रहे हैं?",
      "commentHint": "बताएँ कि स्वीकृति के लिए क्या बदलना होगा।",
      "commentRequired": "अस्वीकार करने के लिए टिप्पणी आवश्यक है। बताएँ कि क्या बदलना होगा।"
    },
    "handover": {
      "request": "हैंडओवर का अनुरोध",
      "title": "इसे किसी दूसरे समीक्षक को सौंपें",
      "body": "अनुरोध को प्रशासक की स्वीकृति चाहिए। तब तक निर्णय आपका ही रहेगा।",
      "to": "किसे सौंपें",
      "toHint": "इस मास्टर टाइप के समीक्षक। सबमिट करने वाले को नहीं चुना जा सकता।",
      "reason": "क्यों?",
      "requested": "हैंडओवर का अनुरोध भेजा गया",
      "incomplete": "पहले एक समीक्षक चुनें और कारण लिखें।",
      "notPending": "इस सबमिशन पर निर्णय हो चुका है, सौंपने को कुछ नहीं है।",
      "notYours": "केवल नियत समीक्षक ही सबमिशन सौंप सकते हैं।"
    },
    "itemCount_one": "{{count}} रिकॉर्ड",
    "itemCount_other": "{{count}} रिकॉर्ड",
    "decide": "निर्णय"
  },
  "users": {
    "title": "उपयोगकर्ता",
    "description": "लोगों को प्रावधानित करें, उनकी पहुँच सक्रिय या निष्क्रिय करें, और भूमिकाएँ प्रदान या रद्द करें।",
    "columns": {
      "email": "उपयोगकर्ता",
      "status": "स्थिति",
      "roles": "भूमिकाएँ",
      "actions": "कार्रवाइयाँ"
    },
    "noRoles": "कोई भूमिका प्रदान नहीं की गई",
    "activate": "सक्रिय करें",
    "activated": "उपयोगकर्ता सक्रिय किया गया",
    "activateNeedsGrant": "सक्रिय करने से पहले एक भूमिका प्रदान करें। बिना भूमिका वाला उपयोगकर्ता हर जगह अस्वीकृत होगा, जो उसे अप्रचालित छोड़ने से भी बुरा है।",
    "deactivate": "निष्क्रिय करें",
    "deactivated": "उपयोगकर्ता निष्क्रिय किया गया",
    "deactivateBlockedDetail": "उनके पास अभी भी नियत लंबित सबमिशन हैं। समीक्षक हैंडओवर या स्थायी समीक्षक नियुक्ति बदलकर इन्हें साफ़ करें, फिर पुनः प्रयास करें।",
    "confirmDeactivate": {
      "title": "इस उपयोगकर्ता को निष्क्रिय करें?",
      "body": "{{email}} की पहुँच तुरंत समाप्त हो जाएगी — उनका सत्र रद्द होता है, केवल अगला साइन-इन नहीं।"
    },
    "empty": {
      "title": "अभी कोई उपयोगकर्ता नहीं",
      "body": "शुरू करने के लिए पहले व्यक्ति को प्रावधानित करें।"
    },
    "roles": {
      "viewer": "दर्शक",
      "creator": "निर्माता",
      "reviewer": "समीक्षक",
      "admin": "प्रशासक",
      "super_admin": "सुपर प्रशासक"
    },
    "provision": {
      "action": "उपयोगकर्ता प्रावधानित करें",
      "title": "एक उपयोगकर्ता प्रावधानित करें",
      "description": "यह खाता बनाता है, पहुँच नहीं। जब तक आप भूमिका प्रदान कर उन्हें सक्रिय नहीं करते, वे साइन इन कर कुछ नहीं कर सकते।",
      "email": "ईमेल",
      "displayName": "नाम",
      "success": "उपयोगकर्ता प्रावधानित किया गया"
    },
    "grant": {
      "action": "भूमिका प्रदान करें",
      "revoked": "भूमिका रद्द की गई",
      "revokeAction": "रद्द करें {{role}} · {{scope}}",
      "title": "एक भूमिका प्रदान करें",
      "description": "{{email}} के लिए।",
      "role": "भूमिका",
      "scope": "मास्टर प्रकार",
      "scopeHint": "हर जगह प्रदान करने के लिए ग्लोबल रहने दें, या इसे एक मास्टर प्रकार तक सीमित करें।",
      "global": "ग्लोबल",
      "alwaysGlobal": "प्रशासक और सुपर प्रशासक हमेशा ग्लोबल होते हैं — इस सिस्टम में \"एक मास्टर प्रकार के प्रशासक\" जैसी कोई अवधारणा नहीं है।",
      "noScopeVisibility": "आपका खाता मास्टर प्रकार नहीं देख सकता, इसलिए यहाँ सीमित भूमिका देने का विकल्प नहीं है। इसके बजाय यह ग्लोबल रूप से प्रदान करता है — यदि आपको इसे एक ही मास्टर प्रकार तक सीमित करना है, तो किसी ऐसे व्यक्ति से कहें जिसके पास मास्टर प्रकार पढ़ने की पहुँच है।",
      "success": "भूमिका प्रदान की गई",
      "confirmRevoke": {
        "title": "इस भूमिका को रद्द करें?",
        "body": "{{email}} से {{role}} · {{scope}} हटाता है। यदि यह उनकी अंतिम भूमिका है, तो वे अप्रचालित स्थिति में लौट आएँगे और तुरंत पहुँच खो देंगे।"
      }
    }
  },
  "handovers": {
    "title": "हैंडओवर",
    "description": "किसी सबमिशन को दूसरे समीक्षक को सौंपने के अनुरोध।",
    "summary": "{{from}} ने इसे {{to}} को सौंपने का अनुरोध किया।",
    "viewSubmission": "सबमिशन देखें",
    "approve": "हैंडओवर स्वीकृत करें",
    "reject": "हैंडओवर अस्वीकार करें",
    "approved": "हैंडओवर स्वीकृत हुआ",
    "rejected": "हैंडओवर अस्वीकार हुआ",
    "empty": {
      "title": "कोई खुला हैंडओवर नहीं",
      "body": "जब कोई समीक्षक सबमिशन किसी और को देना चाहे, अनुरोध यहाँ प्रशासक के निर्णय के लिए दिखेगा।"
    }
  },
  "audit": {
    "masterData": {
      "title": "ऑडिट",
      "description": "मास्टर डेटा और स्कीमा में हर बदलाव — किसने किया, और किसने स्वीकृत किया।"
    },
    "userManagement": {
      "title": "उपयोगकर्ता ऑडिट",
      "description": "उपयोगकर्ता प्रावधान, सक्रियण, और role अनुदान — केवल प्रशासकों को दिखाई देता है।"
    },
    "domain": {
      "label": "डोमेन",
      "masterData": "मास्टर डेटा",
      "schema": "स्कीमा",
      "userManagement": "उपयोगकर्ता प्रबंधन"
    },
    "columns": {
      "occurredAt": "कब",
      "action": "कार्रवाई",
      "entity": "एंटिटी",
      "actor": "किसने किया"
    },
    "filter": {
      "entityType": "एंटिटी प्रकार",
      "entity": "एंटिटी",
      "action": "कार्रवाई",
      "actor": "किसने किया",
      "any": "कोई भी",
      "from": "से",
      "to": "तक"
    },
    "action": {
      "created": "बनाया गया",
      "updated": "अपडेट किया गया",
      "submitted": "सबमिट किया गया",
      "approved": "स्वीकृत",
      "rejected": "अस्वीकृत",
      "deactivated": "निष्क्रिय किया गया",
      "reactivated": "पुनः सक्रिय किया गया",
      "activated": "सक्रिय किया गया",
      "role_granted": "role अनुदान दिया गया",
      "role_revoked": "role अनुदान रद्द किया गया",
      "identity_bound": "साइन-इन जोड़ा गया",
      "imported": "बल्क इम्पोर्ट",
      "handover_requested": "हैंडओवर का अनुरोध किया गया",
      "handover_decided": "हैंडओवर पर निर्णय लिया गया"
    },
    "diff": {
      "changes": "क्या बदला",
      "before": "पहले",
      "after": "बाद में",
      "none": "इस बदलाव के लिए कुछ भी दर्ज नहीं किया गया।"
    },
    "import": {
      "title_one": "बल्क इम्पोर्ट: {{count}} रिकॉर्ड",
      "title_other": "बल्क इम्पोर्ट: {{count}} रिकॉर्ड",
      "badge_one": "{{count}} रिकॉर्ड",
      "badge_other": "{{count}} रिकॉर्ड"
    },
    "export": {
      "action": "एक्सपोर्ट",
      "working": "एक्सपोर्ट हो रहा है…",
      "csv": "CSV के रूप में एक्सपोर्ट करें",
      "xlsx": "XLSX के रूप में एक्सपोर्ट करें",
      "started": "एक्सपोर्ट शुरू हो गया। तैयार होते ही यह अपने आप डाउनलोड हो जाएगा।",
      "failed": "एक्सपोर्ट विफल रहा",
      "pollFailed": "एक्सपोर्ट की प्रगति का पता नहीं चल सका",
      "downloadFailed": "फ़ाइल डाउनलोड नहीं हो सकी। दोबारा एक्सपोर्ट करने की कोशिश करें।"
    },
    "empty": {
      "title": "अभी तक कोई ऑडिट गतिविधि नहीं",
      "body": "कुछ बदलने पर यह यहाँ दिखाई देगा।"
    }
  },
  "bulk": {
    "format": {
      "csv": "CSV",
      "xlsx": "Excel (XLSX)"
    },
    "template": {
      "action": "टेम्पलेट डाउनलोड करें"
    },
    "import": {
      "choose": "फ़ाइल चुनें",
      "action": "अपलोड करें",
      "started": "आयात शुरू हुआ",
      "progress": "{{total}} पंक्तियों में से {{imported}} आयात हुईं, {{failed}} विफल",
      "errorReport": "त्रुटि रिपोर्ट डाउनलोड करें"
    },
    "export": {
      "action": "निर्यात",
      "started": "निर्यात शुरू हुआ",
      "ready": "निर्यात तैयार",
      "download": "निर्यात डाउनलोड करें",
      "rows": "{{count}} पंक्तियाँ"
    },
    "status": {
      "pending": "कतार में",
      "running": "चल रहा है",
      "succeeded": "पूर्ण",
      "partial": "त्रुटियों के साथ पूर्ण",
      "failed": "विफल"
    }
  },
  "tooltips": {
    "approve": "यह बदलाव उन सबके लिए प्रकाशित कर देता है जो इस प्रकार को पढ़ सकते हैं। इसे पूर्ववत नहीं किया जा सकता।",
    "reject": "आपके कारण के साथ वापस भेजता है। बनाने वाला उसे ठीक करके फिर जमा कर सकता है।",
    "requestHandover": "किसी प्रशासक से इसे दूसरे समीक्षक को सौंपने का अनुरोध करता है। उनकी स्वीकृति तक निर्णय आपका ही रहता है।",
    "saveDraft": "यह आप तक ही सीमित रहता है। समीक्षा के लिए जमा करने तक इसे कोई और नहीं देखता।",
    "submitForReview": "इसे समीक्षक को सौंप देता है। प्रतीक्षा के दौरान आप इसे संपादित नहीं कर सकते।",
    "newRecord": "एक ड्राफ़्ट शुरू करता है। समीक्षक की स्वीकृति के बाद ही यह सबको दिखता है।",
    "createType": "मास्टर डेटा का एक नया प्रकार परिभाषित करता है। किसी रिकॉर्ड के उपयोग से पहले इसे स्कीमा चाहिए।",
    "provisionUser": "केवल खाता बनाता है। कुछ भी करने से पहले उन्हें भूमिका और सक्रियण चाहिए।",
    "grantRole": "भूमिका जोड़ता है — या तो हर जगह, या किसी एक मास्टर टाइप तक सीमित।",
    "activateUser": "उन्हें तुरंत पहुँच देता है, उनकी वर्तमान भूमिकाओं के साथ।",
    "deactivateUser": "उनका सत्र तुरंत रद्द करता है, केवल अगली साइन-इन पर नहीं।",
    "approveHandover": "सबमिशन नए समीक्षक को सौंप देता है। तभी मूल समीक्षक से यह हटता है।",
    "rejectHandover": "सबमिशन उसी समीक्षक के पास रहने देता है जिसके पास वह है।",
    "reviewSubmissions": "निर्णय की प्रतीक्षा कर रहे बदलावों की कतार खोलता है।",
    "goToRecords": "मास्टर डेटा स्वयं खोलता है, प्रकार के अनुसार समूहित।",
    "signInGoogle": "साइन इन के लिए आपको Google पर भेजता है। उसके बाद आप यहीं लौट आते हैं।",
    "signInMicrosoft": "साइन इन के लिए आपको Microsoft Entra पर भेजता है। उसके बाद आप यहीं लौट आते हैं।",
    "notFoundHome": "डैशबोर्ड पर वापस ले जाता है।",
    "account": "आप किस रूप में साइन इन हैं, और बाहर निकलने का रास्ता।",
    "checkAgain": "सर्वर से फिर पूछता है कि क्या किसी प्रशासक ने आपको अभी सक्रिय किया।",
    "cancel": "बिना सहेजे बंद कर देता है। आपने जो लिखा वह नहीं रखा जाता।",
    "loadMore": "अगला पृष्ठ लाता है। पहले से दिख रही पंक्तियाँ अपनी जगह रहती हैं।",
    "clearFilters": "हर फ़िल्टर हटाकर पूरी सूची फिर दिखाता है।",
    "retry": "वही अनुरोध दोबारा चलाता है।",
    "editRecord": "ड्राफ़्ट संपादन के लिए खोलता है। जमा करने तक इसे कोई और नहीं देखता।",
    "amendRecord": "नया संस्करण शुरू करता है। समीक्षक की स्वीकृति तक मौजूदा संस्करण ही लागू रहता है।",
    "deactivateRecord": "इस रिकॉर्ड को सेवानिवृत्त करता है। पाठकों से हटने से पहले समीक्षक की स्वीकृति ज़रूरी है।",
    "reactivateRecord": "समीक्षक की स्वीकृति के बाद इस रिकॉर्ड को फिर उपयोग में लाता है।",
    "cascade": "इसके नीचे के हर रिकॉर्ड को भी सेवानिवृत्त करता है — एक ही सबमिशन, जिस पर समीक्षक एक बार निर्णय लेता है।",
    "includeInactive": "सेवानिवृत्त रिकॉर्ड भी सूची में दिखाता है। वे केवल पढ़ने योग्य रहते हैं।",
    "template": "इस प्रकार के कॉलम वाली स्प्रेडशीट डाउनलोड करता है, भरने के लिए तैयार।",
    "chooseFile": "आपके कंप्यूटर से CSV या XLSX फ़ाइल चुनता है। Import दबाने तक कुछ अपलोड नहीं होता।",
    "import": "फ़ाइल अपलोड कर हर पंक्ति जाँचता है। सही पंक्तियाँ एक सबमिशन बनती हैं; बाकी की रिपोर्ट लौटाई जाती है।",
    "cancelUpload": "चुनी हुई फ़ाइल भुला देता है। अभी कुछ अपलोड नहीं हुआ है।",
    "export": "इन रिकॉर्ड की फ़ाइल बनाता है। बड़ी फ़ाइल पृष्ठभूमि में बनती है और तैयार होने पर यहीं दिखती है।",
    "downloadExport": "तैयार फ़ाइल डाउनलोड करता है। लिंक अल्पकालिक है और हर बार नया बनता है।",
    "importErrors": "अस्वीकृत पंक्तियाँ और उनका कारण दिखाता है।",
    "auditExport": "इस ऑडिट ट्रेल की फ़ाइल बनाता है। यह पृष्ठभूमि में बनती है और तैयार होने पर यहीं दिखती है।",
    "submitSchema": "यह संस्करण समीक्षा के लिए भेजता है। स्वीकृति के बाद यही सक्रिय स्कीमा बनता है।",
    "parentType": "इस प्रकार के रिकॉर्ड को किसी अन्य का चाइल्ड बनाता है। शीर्ष-स्तरीय प्रकार के लिए खाली छोड़ें।",
    "fieldType": "तय करता है कि मान क्या हो सकता है, और फ़ॉर्म कौन-सा नियंत्रण दिखाएगा।",
    "fieldTarget": "यह संदर्भ किस मास्टर टाइप की ओर इशारा करता है।",
    "fieldRequired": "इसमें मान दिए बिना रिकॉर्ड सहेजा नहीं जा सकता।",
    "fieldLocalised": "हर लोकेल के लिए अलग मान रखता है, ताकि इस फ़ील्ड का अनुवाद हो सके।",
    "grantRoleSubmit": "भूमिका अभी देता है। यह उनके अगले अनुरोध से लागू होती है।",
    "grantRoleRole": "वे क्या कर सकते हैं। एडमिन और सुपर एडमिन हमेशा वैश्विक होते हैं।",
    "grantRoleScope": "हर जगह देने के लिए Global रहने दें, या एक मास्टर टाइप चुनकर सीमित करें।",
    "provisionSubmit": "खाता बनाता है। कुछ भी करने से पहले उन्हें भूमिका और सक्रियण चाहिए।",
    "statusFilter": "सूची को एक स्थिति तक सीमित करता है। यह आपकी दृष्टि को फ़िल्टर करता है, डेटा को नहीं।",
    "kindFilter": "सूची को रिकॉर्ड बदलावों या स्कीमा बदलावों तक सीमित करता है।",
    "handoverTo": "निर्णय कौन संभालेगा। जिसने इसे जमा किया, उसे नहीं चुना जा सकता।",
    "localeTab": "{{language}} के लिए संग्रहीत मान।"
  },
  "pageHelp": {
    "submissions": "कतार आप नहीं, सर्वर चुनता है — चयनित टैब वही दायरा है जो उसने तय किया, और \"मुझ पर लंबित\" में वे सब शामिल हैं जो अभी किसी को नहीं सौंपे गए।",
    "records": "यहाँ केवल वे मास्टर टाइप दिखते हैं जिन पर आपके पास पढ़ने का अनुदान है। बिना सक्रिय स्कीमा वाला प्रकार रिकॉर्ड ले ही नहीं सकता।",
    "masterTypes": "किसी रिकॉर्ड के उपयोग से पहले प्रकार को सक्रिय स्कीमा चाहिए। पंक्ति खोलने पर उसका स्कीमा खुलता है, उसके रिकॉर्ड नहीं।",
    "users": "प्रावधान, भूमिका देना और सक्रिय करना — तीन अलग चरण, इसी क्रम में। बिना भूमिका वाला खाता हर जगह अस्वीकार होता है, इसीलिए उसे भूमिका के बिना सक्रिय नहीं किया जा सकता।",
    "handovers": "इसका निर्णय केवल प्रशासक ले सकता है। तब तक सबमिशन उसी समीक्षक के पास रहता है — अनुरोध खुला रहने पर कुछ भी रुकता नहीं।"
  }
}
